import { observable, action } from 'mobx'
import moment from 'moment'

class promotionStore {
    @observable showCreatePromotionModal = undefined
    @observable showUpdatePromotionModal = undefined
    @observable showSearchMenuItemModal = undefined
    @observable startDate = undefined
    @observable startTime = undefined
    @observable endDate = undefined
    @observable endTime = undefined

    @action
    init() {
        const today = moment()
        this.setStartDate(today)
        this.setStartTime(today)
        this.setEndDate(today)
        this.setEndTime(today)
        this.setShowCreatePromotionModal(false)
        this.setShowUpdatePromotionModal(false)
        this.setShowSearchMenuItemModal(false)
    }

    @action
    setShowCreatePromotionModal(value) {
        this.showCreatePromotionModal = value
    }

    @action
    setShowUpdatePromotionModal(value) {
        this.showUpdatePromotionModal = value
    }

    @action
    setShowSearchMenuItemModal(value) {
        this.showSearchMenuItemModal = value
    }

    @action
    setStartDate(value) {
        this.startDate = value
    }

    @action
    setStartTime(value) {
        this.startTime = value
    }

    @action
    setEndDate(value) {
        this.endDate = value
    }

    @action
    setEndTime(value) {
        this.endTime = value
    }
}

export default new promotionStore()